import type { CodeType } from '@lms/api-client/backend';

// Canonical numeric codes - single source of truth
const CODE_TABLE_VALUES = {
  PERSONAL: 11, // Legacy - not supported by backend
  STANDARD: 22,
  TENANT_SELECT: 33,
  SUPPLIER_SELECT: 34,
  CUSTOM_SUPPLIER: 44,
} as const;

// For form handling (uses human-readable string keys)
export const CODE_TABLES = {
  person: CODE_TABLE_VALUES.PERSONAL,
  code: CODE_TABLE_VALUES.STANDARD,
  'tenant-code': CODE_TABLE_VALUES.TENANT_SELECT,
  'supplier-code': CODE_TABLE_VALUES.SUPPLIER_SELECT,
  'custom-supplier-code': CODE_TABLE_VALUES.CUSTOM_SUPPLIER,
};

// Map from backend CodeType to numeric code table
export const CODE_TYPE_TO_TABLE: Record<CodeType, number> = {
  standard: CODE_TABLE_VALUES.STANDARD,
  tenant_select: CODE_TABLE_VALUES.TENANT_SELECT,
  supplier_select: CODE_TABLE_VALUES.SUPPLIER_SELECT,
  custom_supplier: CODE_TABLE_VALUES.CUSTOM_SUPPLIER,
};

// Map from numeric code table to backend CodeType
export const TABLE_TO_CODE_TYPE: Record<number, CodeType> = {
  [CODE_TABLE_VALUES.STANDARD]: 'standard',
  [CODE_TABLE_VALUES.TENANT_SELECT]: 'tenant_select',
  [CODE_TABLE_VALUES.SUPPLIER_SELECT]: 'supplier_select',
  [CODE_TABLE_VALUES.CUSTOM_SUPPLIER]: 'custom_supplier',
};

// Translation keys within the `code` namespace.
type CodeTranslationKey =
  | 'personal'
  | 'group'
  | 'tenant'
  | 'supplier'
  | 'supplier_freetext';

// Map from numeric code table to translation key
export const CODE_TRANSLATION_KEY: Record<number, CodeTranslationKey> = {
  [CODE_TABLE_VALUES.PERSONAL]: 'personal',
  [CODE_TABLE_VALUES.STANDARD]: 'group',
  [CODE_TABLE_VALUES.TENANT_SELECT]: 'tenant',
  [CODE_TABLE_VALUES.SUPPLIER_SELECT]: 'supplier',
  [CODE_TABLE_VALUES.CUSTOM_SUPPLIER]: 'supplier_freetext',
};
